export default __webpack_public_path__ + "assets/models/85818bc8cc9c8a9f21e6be616c7a0d23.glb";